import { Navigate } from "react-router-dom"
import { useAuthUser } from "../hooks/useAuth"
import { isFullScope, isTwoFaScope } from "../constants"
import routePaths from "../constants/path"
import FullPageLoader from "./FullPageLoader"

const PublicRoute = ({ component }) => {
  const { data, isLoading, isError } = useAuthUser()

  if (isLoading) return <FullPageLoader />
  if (isError || !data) return <>{component}</>

  if (isFullScope(data.scope)) {
    return <Navigate replace to={routePaths.homepage} />
  }

  if (isTwoFaScope(data.scope)) {
    return data.twoFAEnabled ? (
      <Navigate replace to={routePaths.verifyTwoFa} />
    ) : (
      <Navigate replace to={routePaths.enableTwoFa} />
    )
  }

  return <>{component}</>
}

export default PublicRoute
